(function () {
  'use strict';

  window.addEventListener('scroll', function () {
    document.body.classList.toggle('pp-header-scrolled', window.scrollY > 30);
  }, { passive: true });

  if (!document.querySelector('.pp-sticky-trust')) {
    var bar = document.createElement('div');
    bar.className = 'pp-sticky-trust';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Store guarantees');
    bar.innerHTML = '<strong>★ 5.0 Reviews</strong><span>·</span><strong>30-Day Guarantee</strong><span>·</span><strong>PETS10 10% Off</strong><span>·</span><strong>Buy 2 Save 10%</strong>';
    var header = document.querySelector('.header-wrapper, header, #shopify-section-header');
    if (header && header.parentNode) {
      header.parentNode.insertBefore(bar, header.nextSibling);
    } else {
      document.body.insertBefore(bar, document.body.firstChild);
    }
  }

  var isProduct = document.body.classList.contains('template-product') || /\/products\//.test(location.pathname);
  if (isProduct && !document.querySelector('.pp-social-proof')) {
    var proof = document.createElement('div');
    proof.className = 'pp-social-proof';
    var n = 12 + Math.floor(Math.random() * 18);
    proof.textContent = n + ' pet parents viewed this in the last 24 hours';
    var title = document.querySelector('.product__title');
    if (title && title.parentNode) {
      title.parentNode.insertBefore(proof, title.nextSibling);
    }
  }

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('pp-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -30px 0px' });
    document.querySelectorAll('.pp-reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.pp-reveal').forEach(function (el) { el.classList.add('pp-visible'); });
  }

  document.querySelectorAll('.pp-hero__cta, .pp-cta-band__btn, .button, .product-form__submit').forEach(function (btn) {
    btn.addEventListener('mousedown', function () { btn.style.transform = 'scale(0.97)'; });
    btn.addEventListener('mouseup', function () { btn.style.transform = ''; });
    btn.addEventListener('mouseleave', function () { btn.style.transform = ''; });
  });
})();